module.exports = __webpack_public_path__ + "assets/img/3-1.95abdc13.svg";